/* Phoenix Framers — medal frame product page. */
(function () {
  function init(root) {
    var wrap = root.querySelector('[data-pf-medal]');
    if (!wrap || wrap.__pf) return;
    wrap.__pf = true;
    var form = wrap.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var race = wrap.getAttribute('data-race') || '';
    var master = form.querySelector('[data-pf-variants]');
    var price = wrap.querySelector('[data-pf-price]');
    var submit = form.querySelector('[data-pf-medal-submit]');
    var preview = wrap.querySelector('.pf-mf');
    var mfText = wrap.querySelector('[data-pf-mf-text]');
    var year = form.querySelector('[data-pf-year]');
    var other = form.querySelector('[data-pf-otheryear]');
    var runner = form.querySelector('[data-pf-runner]');
    var time = form.querySelector('[data-pf-time]');
    var layouts = ['medal', 'bib', 'photo'];
    var uploads = form.querySelector('[data-pf-uploads]');
    var bibNo = form.querySelector('[data-pf-bibno]');
    var bibNoTxt = wrap.querySelector('[data-pf-mf-bibno]');
    var bibNoDefault = bibNoTxt ? bibNoTxt.textContent : '';
    var fileErr = form.querySelector('[data-pf-file-error]');
    var urls = {};
    var MAX = 20 * 1024 * 1024;

    function showSlide(i) {
      i = String(i);
      wrap.querySelectorAll('[data-slide]').forEach(function (s) { s.hidden = s.getAttribute('data-slide') !== i; });
      wrap.querySelectorAll('[data-thumb]').forEach(function (b) { b.setAttribute('aria-current', b.getAttribute('data-thumb') === i ? 'true' : 'false'); });
    }
    function layoutNow() {
      var first = form.querySelectorAll('[data-pf-option="0"]');
      var idx = Array.prototype.findIndex.call(first, function (r) { return r.checked; });
      return layouts[idx] || 'medal';
    }
    function syncUploads() {
      if (!uploads) return;
      var lay = layoutNow();
      uploads.hidden = lay === 'medal';
      uploads.querySelectorAll('[data-show]').forEach(function (box) {
        var on = box.getAttribute('data-show').split(' ').indexOf(lay) > -1;
        box.hidden = !on;
        box.querySelectorAll('input').forEach(function (inp) { inp.disabled = !on; });
      });
    }
    function setImage(kind, file) {
      var target = wrap.querySelector(kind === 'photo' ? '[data-pf-mf-photo]' : '[data-pf-mf-bib]');
      var label = form.querySelector('[data-pf-file-label="' + kind + '"]');
      var clear = form.querySelector('[data-pf-file-clear="' + kind + '"]');
      if (urls[kind]) { URL.revokeObjectURL(urls[kind]); urls[kind] = null; }
      if (file) {
        urls[kind] = URL.createObjectURL(file);
        if (target) { target.style.backgroundImage = 'url("' + urls[kind] + '")'; target.classList.add('has-img'); }
        if (label) { label.textContent = file.name; label.parentNode.classList.add('is-set'); }
        if (clear) clear.hidden = false;
        showSlide('preview');
      } else {
        if (target) { target.style.backgroundImage = ''; target.classList.remove('has-img'); }
        if (label) { label.textContent = 'Choose a photo'; label.parentNode.classList.remove('is-set'); }
        if (clear) clear.hidden = true;
      }
    }
    function fileName(kind) {
      var inp = form.querySelector('[data-pf-file="' + kind + '"]');
      return inp && !inp.disabled && inp.files && inp.files[0] ? inp.files[0].name : '';
    }

    function chosen(i) {
      var el = form.querySelector('[data-pf-option="' + i + '"]:checked');
      return el ? el.value : null;
    }
    function optionCount() {
      var n = 0;
      while (form.querySelector('[data-pf-option="' + n + '"]')) n++;
      return n;
    }
    var n = optionCount();

    function syncAvail() { if (!master || n < 2) return; var l = chosen(0), first = null, bad = false; form.querySelectorAll('[data-pf-option="1"]').forEach(function (r) { var ok = Array.prototype.some.call(master.options, function (o) { return o.getAttribute('data-options') === l + '||' + r.value && !o.disabled; }); var lab = r.closest('label'); if (lab) lab.style.display = ok ? '' : 'none'; r.disabled = !ok; if (ok && !first) first = r; if (!ok && r.checked) bad = true; }); if (bad && first) first.checked = true; } function updateVariant() { syncAvail();
      if (!master || !n) return;
      var vals = [];
      for (var i = 0; i < n; i++) vals.push(chosen(i));
      var key = vals.join('||');
      var match = Array.prototype.find.call(master.options, function (o) { return o.getAttribute('data-options') === key; });
      if (match) {
        master.value = match.value;
        if (price && !price.classList.contains('pf-muted')) price.textContent = match.getAttribute('data-price');
        if (submit) { submit.disabled = match.disabled; submit.textContent = match.disabled ? 'Sold out' : 'Add to basket'; }
        try { history.replaceState(null, '', location.pathname + '?variant=' + match.value); } catch (e) {}
      }
      for (var j = 0; j < n; j++) {
        var lbl = wrap.querySelector('[data-pf-optval="' + j + '"]');
        if (lbl) lbl.textContent = '— ' + chosen(j);
      }
      if (preview) {
        var first = form.querySelectorAll('[data-pf-option="0"]');
        var idx = Array.prototype.findIndex.call(first, function (r) { return r.checked; });
        preview.setAttribute('data-layout', layouts[idx] || 'medal');
        syncUploads();
        var fin = chosen(1);
        if (fin) preview.setAttribute('data-finish', fin.toLowerCase().replace(/[^a-z]+/g, '-'));
      }
    }

    function yearValue() {
      if (!year) return '';
      if (year.value === 'Another year') return (other && other.value.trim()) || 'another year';
      return year.value;
    }

    function updateText() {
      if (!mfText) return;
      var bits = [];
      if (runner && runner.value.trim()) bits.push(runner.value.trim().toUpperCase());
      bits.push(race.toUpperCase() + ' · ' + yearValue());
      if (time && time.value.trim()) bits.push(time.value.trim());
      mfText.textContent = bits.join('  ·  ');
    }

    function spec() {
      var lines = ['Medal frame: ' + (wrap.getAttribute('data-product') || race)];
      for (var i = 0; i < n; i++) {
        var leg = form.querySelectorAll('.pf-medal__opt legend')[i];
        var name = leg ? leg.firstChild.textContent.trim() : 'Option ' + (i + 1);
        lines.push(name + ': ' + chosen(i));
      }
      lines.push('Race year: ' + yearValue());
      if (runner && runner.value.trim()) lines.push('Name on mount: ' + runner.value.trim());
      if (time && time.value.trim()) lines.push('Finish time: ' + time.value.trim());
      var h = form.querySelector('[name="properties[Medal handover]"]:checked');
      if (h) lines.push('Medal handover: ' + h.value);
      if (bibNo && !bibNo.disabled && bibNo.value.trim()) lines.push('Bib number: ' + bibNo.value.trim());
      if (fileName('photo')) lines.push('Race photo: ' + fileName('photo') + ' (I will email it)');
      return lines.join('\n');
    }

    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-pf-option]')) {
        updateVariant();
        if (layoutNow() !== 'medal') showSlide('preview');
      }
      if (e.target.matches('[data-pf-file]')) {
        var kind = e.target.getAttribute('data-pf-file');
        var f = e.target.files && e.target.files[0];
        if (fileErr) fileErr.hidden = true;
        if (f && (f.size > MAX || !/^image\//.test(f.type || 'image/'))) {
          if (fileErr) { fileErr.textContent = f.size > MAX ? 'That photo is over 20 MB. Please choose a smaller file.' : 'Please choose a photo (JPG, PNG or HEIC).'; fileErr.hidden = false; }
          e.target.value = '';
          f = null;
        }
        setImage(kind, f);
      }
      if (e.target === year && other) {
        var on = year.value === 'Another year';
        other.hidden = !on; other.disabled = !on; other.required = on;
        if (on) other.focus();
      }
      updateText();
    });
    form.addEventListener('input', function (e) {
      if (e.target === bibNo && bibNoTxt) {
        bibNoTxt.textContent = bibNo.value.trim() || bibNoDefault;
        showSlide('preview');
      }
      updateText();
    });

    wrap.addEventListener('click', function (e) {
      var a = e.target.closest('[data-pf-medal-enquire]');
      if (a) {
        var base = wrap.getAttribute('data-quote-url') || '/pages/request-a-quote';
        a.href = base + (base.indexOf('?') > -1 ? '&' : '?') + 'spec=' + encodeURIComponent(spec());
      }
      var t = e.target.closest('[data-thumb]');
      if (t) showSlide(t.getAttribute('data-thumb'));
      var c = e.target.closest('[data-pf-file-clear]');
      if (c) {
        var k = c.getAttribute('data-pf-file-clear');
        var inp = form.querySelector('[data-pf-file="' + k + '"]');
        if (inp) inp.value = '';
        setImage(k, null);
      }
    });

    updateVariant();
    updateText();
  }
  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
